import React, {useContext, useEffect} from 'react'
import PropTypes from 'prop-types'
import {useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {useForm} from 'react-hook-form'
import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'
import WithdrawalForm from '@consteed/overrides/components/withdrawal'

export const WithdrawalModalContext = React.createContext()
export const useWithdrawalContext = () => useContext(WithdrawalModalContext)

export const WithdrawalModal = ({isOpen, onOpen, onClose}) => {
    const {formatMessage} = useIntl()
    const form = useForm()

    useEffect(() => {
        if (!isOpen) {
            form.reset()
        }
    }, [isOpen])

    return (
        <Modal
            size="sm"
            closeOnOverlayClick={false}
            data-testid="withdrawal-modal"
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton
                    aria-label={formatMessage({
                        id: 'withdrawal_modal.button.close.assistive_msg',
                        defaultMessage: 'Close withdrawal form'
                    })}
                />
                <ModalBody pb={8} bg="white" paddingBottom={14} marginTop={14}>
                    <WithdrawalForm form={form} onClose={onClose} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

WithdrawalModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
}

export const useWithdrawalModal = () => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {pathname} = useLocation()

    useEffect(() => {
        if (isOpen) {
            onClose()
        }
    }, [pathname])

    return {
        isOpen,
        onOpen,
        onClose
    }
}

export const WithdrawalModalProvider = ({children}) => {
    const withdrawalModal = useWithdrawalModal()
    return (
        <WithdrawalModalContext.Provider value={withdrawalModal}>
            {children}
            <WithdrawalModal {...withdrawalModal} />
        </WithdrawalModalContext.Provider>
    )
}

WithdrawalModalProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export default WithdrawalModal
